module.exports = __webpack_public_path__ + "static/img/15.766775d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/huoban/15.png
// module id = 388h
// module chunks = 1